var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPasskeyWindowsHello24({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.8186 5.8128) scale(-1 1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.31856 8.40641C2.92506 10.7342 5.71058 12.3751 8.8048 12.3751C11.702 12.3751 14.2824 11.0219 15.9454 8.91453C16.059 8.77051 16.1684 8.62298 16.2733 8.47211C16.2885 8.45028 16.3036 8.42838 16.3186 8.40641",
    stroke: "#0076E3",
    strokeWidth: 2.63687,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26334 4.1018C5.39602 4.1018 6.31423 3.18358 6.31423 2.0509C6.31423 0.918219 5.39602 0 4.26334 0C3.13065 0 2.21244 0.918219 2.21244 2.0509C2.21244 3.18358 3.13065 4.1018 4.26334 4.1018Z",
    fill: "#0076E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.053 4.1018C14.1857 4.1018 15.1039 3.18358 15.1039 2.0509C15.1039 0.918219 14.1857 0 13.053 0C11.9204 0 11.0021 0.918219 11.0021 2.0509C11.0021 3.18358 11.9204 4.1018 13.053 4.1018Z",
    fill: "#0076E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasskeyWindowsHello24);
export default __webpack_public_path__ + "static/media/icon-passkey-windows-hello-24.2fae7de4fa39f2a788881568eb9ca8bd.svg";
export { ForwardRef as ReactComponent };